import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { NoMarginBottom } from './UserInfoUniversitySelector.styles';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';

export const UserInfoUniversitySelector = () => {
  const form = Form.useFormInstance();
  const { getUniversityOptions } = useUniStudyBranchesOptions();
  const selectedBranch = Form.useWatch('studyBranch', form);
  const selectedDegree = Form.useWatch('degree', form);
  const selectedUniversity = Form.useWatch('university', form);
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const options = getUniversityOptions(selectedBranch, selectedDegree, t('OTHER'));

  return (
    <Box flexDirection="column" gap={12}>
      <NoMarginBottom $isOther={selectedUniversity === 'other'}>
        <Form.Item rules={[RULES.REQUIRED]} name="university">
          <Select
            options={options}
            placeholder={t('SELECT_UNIVERSITY')}
            disabled={!selectedDegree}
            onChange={() => {
              form.setFieldValue('otherUniversity', undefined);
            }}
          />
        </Form.Item>
      </NoMarginBottom>
      {selectedUniversity === 'other' && (
        <Form.Item
          rules={[
            RULES.REQUIRED,
            {
              validator: (_, value) => {
                if (selectedUniversity === 'other' && !value) {
                  return Promise.reject(new Error(t('FIELD_REQUIRED')));
                }
                return Promise.resolve();
              }
            }
          ]}
          name="otherUniversity">
          <Input placeholder={t('OTHER_UNIVERSITY_PLACEHOLDER')} />
        </Form.Item>
      )}
    </Box>
  );
};
